import type { ChartModuleId } from '../domain/types';

export interface ReadingProfile {
  /** 给用户和模型看的本门判断入口，避免十二门术数共用一种话术。 */
  lens: string;
  /** 同一问题下优先挑选的本门字段。 */
  factTerms: string[];
}

const READING_PROFILES: Record<ChartModuleId, ReadingProfile> = {
  liuyao: {
    lens: '六爻先看动爻和世应',
    factTerms: ['动爻', '世爻', '应爻', '世应', '六亲', '用神', '月建', '日辰', '变卦']
  },
  meihua: {
    lens: '梅花先看体卦、用卦和生克',
    factTerms: ['体卦', '用卦', '体用', '生克', '互卦', '动爻', '主卦', '变卦']
  },
  qimen: {
    lens: '奇门先看落宫、门、星、神',
    factTerms: ['宫', '值符', '值使', '门', '星', '神', '主客', '旬首']
  },
  liuren: {
    lens: '六壬先看四课、三传和天将',
    factTerms: ['四课', '三传', '初传', '中传', '末传', '天将', '月将', '取传']
  },
  xiaoliuren: {
    lens: '小六壬先看月、日、时三宫',
    factTerms: ['月宫', '日宫', '时宫', '月课', '日课', '时课', '六神']
  },
  taiyi: {
    lens: '太乙先看主客算和太乙落宫',
    factTerms: ['主算', '客算', '太乙', '文昌', '始击', '主客', '落宫']
  },
  bazi: {
    lens: '八字先看日主、旺衰和十神',
    factTerms: ['日主', '旺衰', '十神', '五行', '月令', '格局', '大运', '流年']
  },
  ziwei: {
    lens: '紫微先看命宫、身宫、主星和四化',
    factTerms: ['命宫', '身宫', '主星', '四化', '官禄', '财帛', '夫妻', '迁移']
  },
  jinkoujue: {
    lens: '金口诀先看地分、将神、贵神和人元',
    factTerms: ['地分', '将神', '贵神', '人元', '四位', '五动', '神将']
  },
  huangli: {
    lens: '黄历先看建除、值神、宜忌和冲煞',
    factTerms: ['建除', '值神', '宜', '忌', '冲煞', '值日', '日课', '吉神', '凶煞']
  },
  'wuyun-liuqi': {
    lens: '五运六气先看岁运、司天、在泉和主客气',
    factTerms: ['岁运', '司天', '在泉', '主气', '客气', '五运', '六气']
  },
  'huangji-jingshi': {
    lens: '皇极经世先看周期位置和卦气',
    factTerms: ['元', '会', '运', '世', '周期', '卦气', '值年卦', '年卦']
  }
};

export function readingProfileFor(moduleId: ChartModuleId): ReadingProfile {
  return READING_PROFILES[moduleId];
}
